import React, { useState } from 'react';
import { Infinity, Brain, Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuItems = [{
    label: 'Inicio',
    href: '#inicio'
  }, {
    label: 'Qué Incluye',
    href: '#que-incluye'
  }, {
    label: 'Beneficios',
    href: '#beneficios'
  }, {
    label: 'Testimonios',
    href: '#testimonios'
  }, {
    label: 'FAQ',
    href: '#faqs'
  }];
  return <header className="fixed top-0 left-0 right-0 z-50 bg-spaceBg/80 backdrop-blur-md border-b border-white/10" data-id="element-138">
      <div className="max-w-7xl mx-auto px-4 h-20 flex items-center justify-between" data-id="element-139">
        {/* Logo */}
        <div className="flex items-center gap-2" data-id="element-140">
          <span className="text-xl md:text-2xl font-black text-white tracking-tight" data-id="element-141">
            InfinitaMenteDigital
          </span>
          <div className="flex items-center gap-1 text-gradPurple" data-id="element-142">
            <Infinity className="w-6 h-6" data-id="element-143" />
            <Brain className="w-5 h-5" data-id="element-144" />
          </div>
        </div>

        {/* Desktop Menu */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-145">
          {menuItems.map((item, index) => <a key={index} href={item.href} className="text-white/80 hover:text-white font-medium transition-colors" data-id="element-146">
              {item.label}
            </a>)}
          <a href="https://checkout.infinita-mente.online/checkouts/cn/hWN9hJcYAJ6aX5aJ3wBC1CQj/es-ar?_r=AQAB8bH0zu89K7bsPll58nLRDWhvvq0TO43BcpK3J-clHp8&preview_theme_id=138558668898" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-r from-[#10B981] to-[#047857] hover:from-[#059669] hover:to-[#065f46] text-white font-bold px-6 py-2 rounded-full transition-colors shadow-[0_0_10px_rgba(16,185,129,0.2)] whitespace-nowrap" data-id="element-147">
            Acceder al MegaPack
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden text-white p-2" data-id="element-148">
          {isMenuOpen ? <X className="w-8 h-8" data-id="element-149" /> : <Menu className="w-8 h-8" data-id="element-150" />}
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      <AnimatePresence data-id="element-151">
        {isMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-cardBg border-b border-white/10 overflow-hidden" data-id="element-152">
            <nav className="flex flex-col px-4 py-6 gap-4" data-id="element-153">
              {menuItems.map((item, index) => <a key={index} href={item.href} onClick={() => setIsMenuOpen(false)} className="text-white/80 hover:text-white font-medium text-lg py-2 border-b border-white/5" data-id="element-154">
                  {item.label}
                </a>)}
              <a href="https://checkout.infinita-mente.online/checkouts/cn/hWN9hJcYAJ6aX5aJ3wBC1CQj/es-ar?_r=AQAB8bH0zu89K7bsPll58nLRDWhvvq0TO43BcpK3J-clHp8&preview_theme_id=138558668898" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-r from-[#10B981] to-[#047857] hover:from-[#059669] hover:to-[#065f46] text-white font-bold px-6 py-3 rounded-full text-center mt-4 shadow-[0_0_10px_rgba(16,185,129,0.2)] transition-colors whitespace-nowrap" data-id="element-155">
                Acceder al MegaPack
              </a>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}